var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","display":"flex","flex-direction":"column"}},_vm._l((_vm.tasks),function(task,index){return _c('div',{key:index},[_c('div',[_c('Task',{attrs:{"task":task}})],1)])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }